module.exports = __webpack_public_path__ + "static/img/23.d463f28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/23.jpg
// module id = 2+I7
// module chunks = 1